// Constants
const SubAPIPostCode_url = "https://83cv7ta60b.execute-api.ap-southeast-2.amazonaws.com";
const datesRangeLimit = 2;

// Extend dayjs with plugins
dayjs.extend(window.dayjs_plugin_utc);
dayjs.extend(window.dayjs_plugin_timezone);
dayjs.extend(window.dayjs_plugin_isSameOrBefore);

const currentDate = dayjs().tz("Australia/Sydney");

// Event Handlers
$(document).ready(() => {
  $(".sticky-postal-sidebar").on("click", () => {
    $('.cart-count').trigger("click");
    $('.checkPostalBtnShipping').trigger("click");
  });

  $(document).on("click", ".delOpt", async function () {
    const allDataAttributes = $(this).data();
    const suburb = allDataAttributes.suburb;
    const postCodeVal = allDataAttributes.postcode;
    const deliveryDate = allDataAttributes.deliveryDate;
    let summaryBtn = qs("#toPlan");
    const deliveryInfo = {
      deliveryDate,
      suburb,
      postcode: postCodeVal
    };
    
    $.ajax({
        url: `${SubAPIPostCode_url}/packing-dates/${suburb}/${postCodeVal}/${datesRangeLimit}/${deliveryDate}`,
        type: "GET",
        success: (response) => {
          const { data, status } = JSON.parse(response);
          if (status && data.length > 0) {
            allDataAttributes.packingDate = data;
          }
          localStorage.setItem("deliveryInfo", JSON.stringify(allDataAttributes));
          summaryBtn.disabled = true;
        },
        error: (xhr, textStatus, errorThrown) => {
          console.error({ errorThrown, xhr, textStatus });
        }
    });

    $('.postCodeForm').animate({
      scrollTop: $(".windowDate").offset().top
    }, 1000);

    $(".windowCheckout").empty();
    $(this).addClass("active-date").siblings().removeClass("active-date");
    // console.log("click delOpt");
  });

  $(document).on("click", ".timeOpt", async function () {
    const allDataAttributes = $(this).data();
    let deliveryInfo = JSON.parse(localStorage.getItem("deliveryInfo")) || {};
    deliveryInfo.deliveryStart = allDataAttributes.deliveryStart;
    deliveryInfo.deliveryEnd = allDataAttributes.deliveryEnd;
    localStorage.setItem("deliveryInfo", JSON.stringify(deliveryInfo));
    setCookie('expecting-delivery', deliveryInfo.deliveryDate, 7);
    //console.log({deliveryInfo});
    
    const { item_count, original_total_price, attributes } = localCart.getCartData();
    const cartAmountInDollars = original_total_price / 100;
    let orderType; 
    if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("keto_customers") && typeof customerData.ketoCustDiscountFixed === "number") {
       orderType = "OneTimePurchase";
     }else{
       orderType = attributes?.orderType?.type || "WeeklySubscription";
     }
    const deliveryDate = getCookie("expecting-delivery");
    const isDeliveryDateSet = deliveryDate !== null;
    updateFutureDeliveries(deliveryInfo.deliveryDate,orderType);
    // Define the minimum cart amount based on order type
    let minCartAmount=0;
    if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("NDIS") && typeof customerData.ndisDiscountPercentage === "number") {
        minCartAmount = orderType === "OneTimePurchase" ? MIN_NDIS_OTP_CART_AMOUNT : MIN_NDIS_SUBS_CART_AMOUNT;
    } else {
        minCartAmount = orderType === "OneTimePurchase" ? MIN_OTP_CART_AMOUNT : MIN_SUBS_CART_AMOUNT;
    }

    // Define common classes for ease of modification
    const addOrangeClasses = ["bg-orange", "border-orange"];
    const removeOrangeClasses = ["checkPostalBtn2", "bg-orange", "border-orange"];
    let summaryBtn = qs("#toPlan");
    if (cartAmountInDollars < minCartAmount) {
        primaryButton.removeAttribute("onclick");
        primaryButton.classList.remove(...removeOrangeClasses);
        primaryButton.innerHTML = `Add $${(minCartAmount - cartAmountInDollars).toFixed(2)} more to your cart`;
        summaryBtn.disabled = false;
    } else {
        if (isDeliveryDateSet) {
            primaryButton.setAttribute("onclick", "localCart.continueToShipping('mini-cart')");
            primaryButton.classList.add(...addOrangeClasses);
            primaryButton.classList.remove("checkPostalBtn2");
            primaryButton.innerHTML = 'Checkout Now';
            summaryBtn.disabled = false;
        } else {
            primaryButton.removeAttribute("onclick");
            primaryButton.classList.add("checkPostalBtn2");
            primaryButton.classList.remove(...addOrangeClasses);
            primaryButton.innerHTML = 'Select Delivery Date and Checkout';
            summaryBtn.disabled = true;
        }
    }
    
    /*$(".windowCheckout").html(elementToAppend);*/
    $(this).addClass("active-time").siblings().removeClass("active-time");
    
    $('.postCodeForm').animate({
      scrollTop: $(".windowTime").offset().top
    }, 1000);
  });

});

// Functions
const updateTimeSlots = (data, selectedDate) => {
  const timeSlotsContainer = $('<div class="windowTime"><label>Time Slots:</label><div class="nextTime"></div></div>');
  const dateInfoArray = data[selectedDate];
  
  const morningSlot = dateInfoArray.find(slot => slot.time_start === "00:00:00" && slot.time_end === "07:00:00");
  const daySlot = dateInfoArray.find(slot => slot.time_start === "08:00:00" && slot.time_end === "18:00:00");

  if (morningSlot) {
    const morningTimeStart = formatTime(morningSlot.time_start);
    const morningTimeEnd = formatTime(morningSlot.time_end);
    const morningHtmlInsert = $('<div class="timeOpt"></div>')
      .text(`${morningTimeStart} - ${morningTimeEnd}`)
      .data("deliveryStart", morningSlot.time_start)
      .data("deliveryEnd", morningSlot.time_end);
    timeSlotsContainer.find('.nextTime').append(morningHtmlInsert);
  }

  if (daySlot) {
    const dayTimeStart = formatTime(daySlot.time_start);
    const dayTimeEnd = formatTime(daySlot.time_end);
    const dayHtmlInsert = $('<div class="timeOpt"></div>')
      .text(`${dayTimeStart} - ${dayTimeEnd}`)
      .data("deliveryStart", daySlot.time_start)
      .data("deliveryEnd", daySlot.time_end);
    timeSlotsContainer.find('.nextTime').append(dayHtmlInsert);
  }
  //$(".windowDeliery").empty();
  $(".windowTime").replaceWith(timeSlotsContainer);
};

const formatTime = (time) => {
  if (time === "00:00:00") return "Midnight";
  const [hours, minutes] = time.split(':');
  const intHours = parseInt(hours, 10);
  const period = intHours < 12 ? 'AM' : 'PM';
  const formattedHours = intHours % 12 || 12; // Convert 0 to 12 for midnight
  return `${formattedHours}:${minutes} ${period}`;
};

const updateFutureDeliveries = (selectedDate, subscriptionType) => {

  const updateFutureDeliveriesContainer = $(`
    <div class="windowDeliery d-none"> 
      <label>Future Delivery Cycles:</label>
      <div class="nextDeliveries"></div>
    </div>
  `);

  let updateFutureDeliveriesContainerNew = '';

  const startDate = dayjs(selectedDate);

  // Interval: 7 days (Weekly) or 14 days (Fortnightly)
  const intervalDays = subscriptionType === "WeeklySubscription" ? 7 : 14;

  // Generate next 4 delivery dates
  for (let i = 0; i <= 3; i++) {
    const nextDate = startDate.add(intervalDays * i, "day");

    // Format: Fri Oct 03
    const formatted = nextDate.format("ddd MMM DD");

    updateFutureDeliveriesContainer.find(".nextDeliveries")
      .append(`<div class="p-2 bg-white border-green rounded">${formatted}</div>`); 
      
    updateFutureDeliveriesContainerNew += `<span>${i > 0 ? ', ' : ''}${formatted}</span>`;     
  }
  //console.log(updateFutureDeliveriesContainerNew);

  $(".windowDeliery").replaceWith(updateFutureDeliveriesContainer).removeClass("d-none");; 
  $(".nextDeliveriesNew").html(updateFutureDeliveriesContainerNew);

};



const listSuburbsBasedOnPostCode = (postCodeVal, suburb, expectedDate = currentDate) => {
  $(".text-failer").addClass("d-none");
  $(".loading").removeClass("d-none");

  const windowSuburbCont = $(".windowSuburbCont");
  windowSuburbCont.empty();
  $(".windowDate, .windowTime").addClass("d-none");
  $(".windowCheckout").empty();
  const nextDel = $(".nextDel");
  nextDel.empty();

  if (!postCodeVal || postCodeVal.length < 4) {
    $("#postcode2").addClass("error");
    $(".loading").addClass("d-none");
    return;
  }

  // ✅ Read previous selection
  const loca_del = JSON.parse(localStorage.getItem("deliveryInfo") || "{}");
  const previouslySelectedDate = loca_del.deliveryDate || null;

  $.ajax({
    url: `${SubAPIPostCode_url}/delivery-dates/${suburb}/${postCodeVal}/${datesRangeLimit}/${expectedDate.format("YYYY-MM-DD")}`,
    type: "GET",
    success: (response) => {
      const { data: dataValues = {}, status } = JSON.parse(response);

      let summaryBtn = qs("#toPlan");
      summaryBtn.disabled = true;

      if (status || Object.keys(dataValues).length > 0) {
        const deliveryDatesContainer = $('<div class="windowDate"><label>Delivery Dates:</label><div class="nextDel"></div></div>');

        $.each(Object.keys(dataValues), (index, value) => {
          if (index >= 4) return false;
          const shipDate = new Date(value);
          const shipDateString = shipDate.toDateString().replace(shipDate.getFullYear(), "");
          const dateInfoArray = dataValues[value];

          const deliveryHtmlInsert = $('<div class="delOpt"></div>')
            .text(shipDateString)
            .data({
              "deliveryDate": value,
              "suburb": suburb,
              "postcode": postCodeVal
            })
            .on('click', () => updateTimeSlots(dataValues, value));

          // ✅ Preselect date ONLY (if it matches stored deliveryDate)
          if (previouslySelectedDate && previouslySelectedDate === value) {
            deliveryHtmlInsert.addClass("active-date");
            // Optionally pre-render time slots UI but no time is stored
            updateTimeSlots(dataValues, value);
          }
          deliveryDatesContainer.find('.nextDel').append(deliveryHtmlInsert);
        });

        $(".resultMessage, .text-failer").addClass("d-none");
        $(".windowDate").replaceWith(deliveryDatesContainer).removeClass("d-none");
        
      } else {
        $(".windowDate, .windowTime, .resultMessage").addClass("d-none");
        $(".text-failer").removeClass("d-none").html("Delivery to your area is currently unavailable. Please <a href='/pages/contact-us'>contact us</a> for assistance.");
      }
    },
    error: (xhr, textStatus, errorThrown) => {
      console.error({ errorThrown, xhr, textStatus });
      $(".text-failer").removeClass("d-none");
    },
    complete: () => {
      $(".loading").addClass("d-none");
    },
  });
};

// Rohit Tawar check address valid or not 
const addressConfirmPostCode = (postCodeVal, suburb, expectedDate = currentDate) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `${SubAPIPostCode_url}/delivery-dates/${suburb}/${postCodeVal}/${datesRangeLimit}/${expectedDate.format("YYYY-MM-DD")}`,
      type: "GET",
      success: (response) => {
        try {          
        const { data: dataValues={}, status } = JSON.parse(response);
          if ((status ==true) && (Object.keys(dataValues).length > 0)) {
            resolve("Success");
          } else {
            resolve("Notfound");
          }
        } catch (err) {
          reject("Error");
        }
      },
      error: () => {
        reject("Error");
      }
    });
  });
};